import api from '@lib/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useDeleteIdea = () => {
	const queryClient = useQueryClient()

	return useMutation<void, Error, { tripId: string; ideaId: string }>({
		mutationFn: async ({ ideaId }) => {
			await api.delete(`/ideas/${ideaId}`)
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: ['ideas', variables.tripId] })
		},
	})
}
